import { ReactComponent as Apple } from "../../../assets/download-apple.svg";

export default function DowloadApp() {
  return (
    <div className="row row-sm">
      <div className="css-dx6lmr">
        <a
          id="enableGA_a_appStore"
          href="https://itunes.apple.com/us/app/google-authenticator/id388497605?mt=8"
          target="_blank"
          rel="noreferrer noopener"
          className="css-ovthrp"
        >
          <Apple className="css-1sysnl8" />
          <div className="css-1sgz1lk">
            <div className="css-vurnku">Download from</div>
            <div className="css-1gubtqr">App Store</div>
          </div>
        </a>
        <a
          id="enableGA_a_googlePlay"
          href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2"
          target="_blank"
          rel="noreferrer noopener"
          className="css-1i0rbqg"
        >
          <img
            src="img/download-google.svg"
            className="css-1sysnl8"
            alt="download-google"
          />
          <div className="css-1sgz1lk">
            <div className="css-vurnku">Download from</div>
            <div className="css-1gubtqr">Google Store</div>
          </div>
        </a>
      </div>
    </div>
  );
}
